'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mystudy = function mystudy() {
  return import('@/page/mystudy');
};
var mystudyList = function mystudyList() {
  return import('@/page/mystudy/tab.vue');
};
var mystudyDetail = function mystudyDetail() {
  return import('@/page/course/course-detail');
};
exports.default = [{
  path: '/mystudy',
  name: 'mystudy',
  component: mystudy,
  children: [{
    path: 'mystudy-list',
    name: 'mystudy-list',
    component: mystudyList
  }, {
    path: 'mystudy-detail',
    name: 'mystudy-detail',
    component: mystudyDetail
  }]
}];